import React from "react";
import "./EmptyState.scss";

/**
 * EmptyState — Indicador de estado vacío con pasos de guía.
 *
 * Props:
 *   icon       string       Nombre de ícono Material Symbols (default: "inbox").
 *   title      string       Mensaje principal que se muestra debajo del ícono.
 *   steps      array        Lista de pasos: [{ icon: string, label: ReactNode }]
 *   className  string       Clases CSS adicionales.
 */
const EmptyState = ({ icon = "inbox", title, steps = [], className = "" }) => {
    return (
        <div className={`EmptyState ${className}`.trim()}>
            <span className="material-symbols-outlined es-icon">{icon}</span>
            {title && <p className="es-title">{title}</p>}
            {steps.length > 0 && (
                <div className="es-steps">
                    {steps.map((step, i) => (
                        <div key={i} className="es-step">
                            <span className="step-num">{i + 1}</span>
                            <span className="material-symbols-outlined">{step.icon}</span>
                            <span>{step.label}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default EmptyState;
